/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_No_Event_AddedInputs */

const en_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event (added)`)
};

const fr_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement (ajouté)`)
};

const de_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ereignis (hinzugefügt)`)
};

const it_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento (aggiunto)`)
};

const ru_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событий нет (добавлено)`)
};

const es_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún evento (añadido)`)
};

const zh_cn2_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无事件（已添加）`)
};

const ja_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントなし（追加）`)
};

const hi_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई इवेंट नहीं (जोड़ा गया)`)
};

const pt_pt2_compare_event_groups_no_event_added = /** @type {(inputs: Compare_Event_Groups_No_Event_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento (adicionado)`)
};

/**
* | output |
* | --- |
* | "No event (added)" |
*
* @param {Compare_Event_Groups_No_Event_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_no_event_added = /** @type {((inputs?: Compare_Event_Groups_No_Event_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_No_Event_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_no_event_added(inputs)
	if (locale === "de") return de_compare_event_groups_no_event_added(inputs)
	if (locale === "it") return it_compare_event_groups_no_event_added(inputs)
	if (locale === "ru") return ru_compare_event_groups_no_event_added(inputs)
	if (locale === "es") return es_compare_event_groups_no_event_added(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_no_event_added(inputs)
	if (locale === "ja") return ja_compare_event_groups_no_event_added(inputs)
	if (locale === "hi") return hi_compare_event_groups_no_event_added(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_no_event_added(inputs)
	return en_compare_event_groups_no_event_added(inputs)
});